import { createSlice } from "@reduxjs/toolkit";

import {
  getProfileThunk,
  updateProfileThunk,
  updatePictureProfileThunk,
  getUserThunk,
  updateUserRolesThunk,
  getUserRoleThunk,
  createUserThunk,
  deleteUserThunk,
  updateUserThunk,
} from "state/action/user";

// note: initial state
const initialState = {
  getProfile: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  createUser: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  updateUser: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  updateProfile: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  updatePictureProfile: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  getUser: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  getBadgeUser: {
    data: null,
    isPending: false,
    isFulfilled: false,
    isRejected: false,
    err: null,
  },
  editRolesSelect: {
    roles: [],
  },
  updateRoles: {
    data: null,
    isPending: true,
    isFulfilled: false,
    isRejected: false,
    err: null,
  },
  getUserRole: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  paginate: {
    // note: it uses for "user" fitur on administrator.
    metadata: {
      current_page: 1,
      result_per_page: 10,
    },
  },
  search: {
    // note: it uses for "user" fitur on administrator.
    value: "",
    debounceValue: "",
  },
  // note: handle picture.
  picture: {
    isPreview: false,
    blobImage: "", // note: must be blob.
  },

  // note: pelette
  pelette: {
    mode: "light",
  },
  addUserInputBody: {
    fullname: "",
    email: "",
    password: "",
    roles: [],
    role: "",
    directorate: "",
    division: "",
    department: "",
    accessScope: "",
    working_unit: [],
    picture: {
      file: "",
      url: "",
    },
  },
  addUserInternalInputBody: {
    employee_name: "",
    employee_id: "",
    user_type: "internal",
    position_name: "",
    is_head_unit: false,
    email: "",
    password: "",
    roles: [],
    role: "",
    directorate: "",
    division: "",
    department: "",
    accessScope: "",
    picture: {
      file: "",
      url: "",
    },
  },

  selectedUserInternal: {
    employee_name: "",
    employee_id: "",
    user_type: "internal",
    position_name: "",
    email: "",
    password: "",
    roles: [],
    role: "",
    directorate: "",
    division: "",
    department: "",
    accessScope: "",
    picture: {
      file: "",
      url: "",
    },
  },
  selectedUser: {
    fullname: "",
    email: "",
    password: "",
    roles: [],
    department: "",
    working_unit: [],
    picture: {
      file: "",
      url: "",
    },
  },
  createUserSchemaInputBody: {
    // Identity
    employee_name: "",
    email: "",
    password: "",
    employee_id: "",
    position_name: "",
    picture: null,

    // System & Context
    user_type: "internal",
    company: "", // Company ID
    primaryWorkUnit: "", // WorkUnit ID
    is_head_unit: false,

    // Security & Access
    role: "", // Primary Role ID
    accessScope: "own",

    // Advanced Roles Assignment (Array)
    roles: [], // { role: ID, workUnit: ID, expiresAt: Date }

    // Flags
    isActive: true,
    isCompanyAdmin: false,
    isSuperAdmin: false,
    settings: ["dark", "en"],
  },
  drawerOpen: false,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserField: (state, action) => {
      const { field, value } = action.payload;
      state.createUserSchemaInputBody[field] = value;
    },
    // --- Complex Roles Management ---
    addAssignmentRole: (state) => {
      state.createUserSchemaInputBody.roles.push({
        role: "",
        workUnit: "", // Can be different from primary
        expiresAt: null,
      });
    },
    removeAssignmentRole: (state, action) => {
      state.createUserSchemaInputBody.roles.splice(action.payload, 1);
    },
    updateAssignmentRole: (state, action) => {
      const { index, field, value } = action.payload;
      state.createUserSchemaInputBody.roles[index][field] = value;
    },
    resetUserForm: (state) => {
      state.createUserSchemaInputBody = initialState.createUserSchemaInputBody;
    },

    // Handler khusus untuk upload gambar
    setPicture: (state, action) => {
      // Payload: { file: File, url: string }
      state.addUserInputBody.picture = action.payload;
    },

    setEditRolesSelect(state, action) {
      return {
        ...state,
        editRolesSelect: action.payload,
      };
    },
    setUserInternalField: (state, action) => {
      const { field, value } = action.payload;
      state.addUserInternalInputBody[field] = value;
    },
    // Handler khusus untuk upload gambar
    setPictureUserInternal: (state, action) => {
      // Payload: { file: File, url: string }
      state.addUserInternalInputBody.picture = action.payload;
    },
    resetUserInternalForm: (state) => {
      state.addUserInternalInputBody = initialState.addUserInternalInputBody;
    },
    // setEditRolesSelect(state, action) {
    //   return {
    //     ...state,
    //     editRolesSelect: action.payload,
    //   };
    // },
    setSelectedUser: (state, action) => {
      return {
        ...state,
        selectedUser: action.payload,
      };
    },
    setSelectedUserInternal: (state, action) => {
      return {
        ...state,
        selectedUserInternal: action.payload,
      };
    },
    // note: cleare state
    setClearGetProfile: (state, _) => {
      return {
        ...state,
        getProfile: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setDrawerOpen: (state, action) => {
      return action.payload;
    },
    setClearGetUser: (state, _) => {
      return {
        ...state,
        getUser: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearUpdatePictureProfile: (state, _) => {
      return {
        ...state,
        updatePictureProfile: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearUpdateUserRoles: (state, _) => {
      return {
        ...state,
        updateRoles: {
          data: null,
          isPending: true,
          isFulfilled: false,
          isRejected: false,
          err: null,
        },
      };
    },
    // note: paginate for handle metada
    setPaginateUser: (state, action) => {
      return {
        ...state,
        paginate: {
          metadata: action.payload,
        },
      };
    },
    setSearchUser: (state, action) => {
      return {
        ...state,
        search: action.payload,
      };
    },

    setClearGetBadgeUser: (state, _) => {
      return {
        ...state,
        getBadgeUser: {
          data: null,
          isPending: false,
          isFulfilled: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearAllUserState: (state, _) => {
      return {
        ...state,
        getProfile: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        updateProfile: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        updatePictureProfile: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        getUser: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        getBadgeUser: {
          data: null,
          isPending: false,
          isFulfilled: false,
          isRejected: false,
          err: null,
        },
        editRolesSelect: {
          roles: [],
        },
        updateRoles: {
          data: null,
          isPending: true,
          isFulfilled: false,
          isRejected: false,
          err: null,
        },
        getUserRole: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        paginate: {
          // note: it uses for "user" fitur on administrator.
          metadata: {
            current_page: 1,
            result_per_page: 10,
          },
        },
        search: {
          // note: it uses for "user" fitur on administrator.
          value: "",
          debounceValue: "",
        },
        // note: handle picture.
        picture: {
          isPreview: false,
          blobImage: "", // note: must be blob.
        },
      };
    },
    // note: pelette
    setPelette: (state, action) => {
      return {
        ...state,
        pelette: action.payload,
      };
    },
  },
  extraReducers(builder) {
    builder
      // note: get profile reducer
      .addCase(getProfileThunk.pending, (state, _) => {
        return {
          ...state,
          getProfile: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getProfileThunk.fulfilled, (state, action) => {
        return {
          ...state,
          getProfile: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getProfileThunk.rejected, (state, action) => {
        return {
          ...state,
          getProfile: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // note: update profile reducer
      .addCase(updateProfileThunk.pending, (state, _) => {
        return {
          ...state,
          updateProfile: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateProfileThunk.fulfilled, (state, action) => {
        return {
          ...state,
          updateProfile: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateProfileThunk.rejected, (state, action) => {
        return {
          ...state,
          updateProfile: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // note: update picture reducer
      .addCase(updatePictureProfileThunk.pending, (state, _) => {
        return {
          ...state,
          updatePictureProfile: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updatePictureProfileThunk.fulfilled, (state, action) => {
        return {
          ...state,
          updatePictureProfile: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updatePictureProfileThunk.rejected, (state, action) => {
        return {
          ...state,
          updatePictureProfile: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // note: get user
      .addCase(getUserThunk.pending, (state, _) => {
        return {
          ...state,
          getUser: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getUserThunk.fulfilled, (state, action) => {
        return {
          ...state,
          getUser: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getUserThunk.rejected, (state, action) => {
        return {
          ...state,
          getUser: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // note: update user roles
      .addCase(updateUserRolesThunk.pending, (state, _) => {
        return {
          ...state,
          updateRoles: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateUserRolesThunk.fulfilled, (state, action) => {
        return {
          ...state,
          updateRoles: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateUserRolesThunk.rejected, (state, action) => {
        return {
          ...state,
          updateRoles: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // note: get user role
      .addCase(getUserRoleThunk.pending, (state, _) => {
        return {
          ...state,
          getUserRole: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getUserRoleThunk.fulfilled, (state, action) => {
        return {
          ...state,
          getUserRole: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getUserRoleThunk.rejected, (state, action) => {
        return {
          ...state,
          getUserRole: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // note: create user
      .addCase(createUserThunk.pending, (state, _) => {
        return {
          ...state,
          createUser: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createUserThunk.fulfilled, (state, action) => {
        return {
          ...state,
          createUser: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createUserThunk.rejected, (state, action) => {
        return {
          ...state,
          createUser: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // note: update user
      .addCase(updateUserThunk.pending, (state, _) => {
        return {
          ...state,
          updateUser: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateUserThunk.fulfilled, (state, action) => {
        return {
          ...state,
          updateUser: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateUserThunk.rejected, (state, action) => {
        return {
          ...state,
          updateUser: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      });
  },
});

export const userAction = {
  ...userSlice.actions,
  getProfileThunk,
  updateProfileThunk,
  updatePictureProfileThunk,
  getUserThunk,
  updateUserRolesThunk,
  getUserRoleThunk,
  deleteUserThunk,
  createUserThunk,
  updateUserThunk,
};

export function selectUser(state) {
  return state?.user;
}

export function selectEditRolesSelect(state) {
  return state?.user?.editRolesSelect;
}

export function selectUpdatePictureProfile(state) {
  return state?.user?.updatePictureProfile;
}

// note: paginate select of user
export function selectPaginateUser(state) {
  return state?.user?.paginate;
}

// note: search select of user
export function selectSearchUser(state) {
  return state?.user?.search;
}

// note: pelette
export function selectPelette(state) {
  return state?.user?.pelette;
}

export function selectPicture(state) {
  return state?.user?.picture;
}

export default userSlice.reducer;
